import { defineStore } from 'pinia'
import { Ref, ref } from 'vue'
import { HtmlFormAction } from '@/components/PaymentRequest/types'

export const useHtmlFormStore = defineStore('payment-request-html-form-store', () => {
  const paymentRequestFormRef: Ref<HTMLFormElement | null> = ref(null)
  const submitForm = async (formAction: HtmlFormAction) => {
    if (!paymentRequestFormRef.value?.$el) return
    paymentRequestFormRef.value?.$el.setAttribute('action', formAction)
    paymentRequestFormRef.value?.$el.submit()
  }

  return {
    paymentRequestFormRef,
    submitForm,
  }
})
